import { render } from "./CometChatUserDetails.vue?vue&type=template&id=a57ca0da&scoped=true"
import script from "./CometChatUserDetails.vue?vue&type=script&lang=js"
export * from "./CometChatUserDetails.vue?vue&type=script&lang=js"

import "./CometChatUserDetails.vue?vue&type=style&index=0&id=a57ca0da&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57ca0da"]])

export default __exports__